import IconLate from 'assets/img/status_late.svg';
import IconOffline from 'assets/img/status_offline.svg';
import IconOnline from 'assets/img/status_online.svg';
import { Checkbox, Loader } from 'components';
import {
  ReactElement, ReactNode, useMemo, useState,
} from 'react';
import { Box, Flex } from 'reflexbox';
import { filterManyByColumns, orderByColumns } from '~/helpers/filterByColumns';
import { useStateVar } from '~/helpers/useStateVar';
import { colors } from '~/styles/colors';
import { StyledLink, TableNew2 } from './styles';
import { DeviceRow, PageState } from './types';

interface DevsTableProps {
  pageState: PageState,
  loading: boolean
}

export function DevsTable(props: Readonly<DevsTableProps>): ReactElement {
  const { pageState: state } = props;
  const [localState, renderDevsTable, setLocalState] = useStateVar({
    sortBy: 'CLIENT_NAME',
  });
  state.renderDevsTable = renderDevsTable;

  state.filteredMachines = useMemo(() => {
    const columns: (keyof typeof state.allDevs[0])[] = ['STATE_ID', 'CITY_NAME', 'UNIT_NAME', 'CLIENT_NAME', 'machineName', 'DEV_ID', 'firmwareText', 'status', 'last_update_result', 'OTAPROCSTATUS', 'FWVERSSTATUS'];
    const filtered = filterManyByColumns(state.allDevs, columns, state.searchState);
    if (localState.sortBy) {
      orderByColumns(filtered, localState.sortBy, false);
    }
    return filtered;
  }, [state.searchState, state.allDevs]);

  function toggleCheckAll() {
    const checkState = !(state.filteredMachines[0] && state.filteredMachines[0].checked);
    for (const dev of state.filteredMachines) {
      dev.checked = checkState;
    }
    state.renderUpper();
    state.renderDevsTable();
  }

  function setSorting(column: string) {
    setLocalState({ sortBy: column });
  }

  function renderStatus(dev: DeviceRow): ReactNode {
    switch (dev.status) {
      case 'ONLINE': return (
        <img src={IconOnline} alt="icon-online" />
      );
      case 'OFFLINE': return (
        <img src={IconOffline} alt="icon-offline" />
      );
      case 'LATE': return (
        <img src={IconLate} alt="icon-late" />
      );
      default: return (dev.status || '-');
    }
  }

  if (props.loading) {
    return (
      <Loader variant="primary" />
    );
  }

  return (
    <Flex flexWrap="wrap">
      <Box width={1} style={{ minHeight: 300 }}>
        <TableNew2 style={{ color: colors.Grey400 }}>
          <thead>
            <tr>
              <th onClick={() => setSorting('STATE_ID')}>Estado</th>
              <th onClick={() => setSorting('CITY_NAME')}>Cidade</th>
              <th onClick={() => setSorting('CLIENT_NAME')}>Cliente</th>
              <th onClick={() => setSorting('UNIT_NAME')}>Unidade</th>
              <th onClick={() => setSorting('machineName')}>Grupo</th>
              <th onClick={() => setSorting('DEV_ID')}>Dispositivo</th>
              <th onClick={() => setSorting('status')}>Status</th>
              <th onClick={() => setSorting('col_firmware_s')}>Firmware</th>
              <th onClick={() => setSorting('last_update_result')}>Status OTA</th>
              <th onClick={() => setSorting('FWVERSSTATUS')}>Versão Correta</th>
              <th onClick={() => setSorting('OTAPROCSTATUS')}>Comando OTA</th>
              <th><Checkbox checked={false} onClick={toggleCheckAll} style={{ display: 'inline-flex' }} /></th>
            </tr>
          </thead>
          <tbody>
            {state.filteredMachines.filter((x, i) => (i < state.limitItems)).map((dev) => (
              <tr key={dev.DEV_ID}>
                <td>{dev.STATE_ID || '-'}</td>
                <td>{dev.CITY_NAME || '-'}</td>
                <td>{dev.CLIENT_NAME || '-'}</td>
                <td>{dev.UNIT_ID ? <StyledLink to={`/analise/unidades/${dev.UNIT_ID}`}>{dev.UNIT_NAME}</StyledLink> : '-'}</td>
                <td>{dev.machineName || '-'}</td>
                <td><StyledLink to={`/analise/dispositivo/${dev.DEV_ID}/informacoes`}>{dev.DEV_ID}</StyledLink></td>
                <td>{renderStatus(dev)}</td>
                <td>{(dev.col_firmware_s || '-')}</td>
                <td>{dev.last_update_result || '-'}</td>
                <td>{dev.FWVERSSTATUS || '-'}</td>
                <td>{dev.OTAPROCSTATUS || '-'}</td>
                <td><RowCheckbox pageState={state} dev={dev} /></td>
              </tr>
            ))}
          </tbody>
        </TableNew2>
        {(state.limitItems < state.filteredMachines.length)
          && (
          <p>
            Carregando mais itens... (
            {state.limitItems}
            {' '}
            /
            {' '}
            {state.filteredMachines.length}
            )
          </p>
          )}
      </Box>
    </Flex>
  );
}

function RowCheckbox(props: Readonly<{ dev: DeviceRow, pageState: PageState }>): ReactElement {
  const { dev, pageState: state } = props;
  const [_, renderCheckbox] = useState({});
  return <Checkbox checked={dev.checked} onClick={() => { dev.checked = !dev.checked; renderCheckbox({}); state.renderUpper(); }} />;
}
